<template>
  <div class="index-banner postion">
    <div v-if="banners.length > 0">
      <swiper
          :modules="[Navigation, Pagination, Autoplay]"
          :slides-per-view="1"
          :space-between="0"
          :loop="true"
          :autoplay="{ delay: 3000, disableOnInteraction: false }"
          :pagination="{ clickable: true, el: '.swiper-pagination-banner' }"
          :navigation="{ nextEl: '.swiper-button-next-c', prevEl: '.swiper-button-prev-c' }"
          class="swiper1 over"
      >
        <swiper-slide v-for="(banner, index) in banners" :key="index">
          <dl>
            <dt>
              <img :src="getImageUrl(banner.image_url)" :alt="banner.title" class="banner-image PcShow"/>
              <img :src="getImageUrl(banner.image_url)" :alt="banner.title" class="WapShow"/>
            </dt>
            <dd>
              <h2>{{ banner.title }}</h2>
              <p>{{ banner.subtitle }}</p>
              <router-link v-if="banner.link_url" :to="banner.link_url">
                <i>{{ banner.link_text || '了解更多' }}</i>
                <img src="/images/u16.svg" alt=""/>
              </router-link>
              <span v-else class="default-link">
                <i>了解更多</i>
                <img src="/images/u16.svg" alt=""/>
              </span>
            </dd>
          </dl>
        </swiper-slide>
        <div class="swiper-pagination swiper-pagination-banner"></div>
      </swiper>
      <div id="swiper-button">
        <div class="swiper-button swiper-button-prev-c swiper-button-prev-banner"><img src="/images/Prev.svg" alt="上一个"/></div>
        <div class="swiper-button swiper-button-next-c swiper-button-next-banner"><img src="/images/Prev.svg" alt="下一个"/></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { getBanner } from '@/api/request.js';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default {
  name: 'IndexBanner',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      banners: [],
      loading: false,
      error: null
    };
  },
  async mounted() {
    await this.fetchBanners();
  },
  methods: {
    async fetchBanners() {
      try {
        this.loading = true;
        this.error = null;
        const response = await getBanner();

        // 根据API文档，数据在response.list中
        if (response && response.list && Array.isArray(response.list)) {
          this.banners = response.list.filter(banner => banner.is_active === 1).map(banner => ({
            ...banner,
            link_url: this.processLinkUrl(banner.link_url) // 处理链接
          }));
        } else {
          // 如果API返回的数据结构不同，直接使用response
          this.banners = Array.isArray(response) ? response.map(banner => ({
            ...banner,
            link_url: this.processLinkUrl(banner.link_url) // 处理链接
          })) : [];
        }

        // 如果没有获取到数据，使用默认数据
        if (this.banners.length === 0) {
          this.setDefaultBanners();
        }
      } catch (error) {
        console.error('获取Banner数据失败:', error);
        this.error = error.message;
        // 出错时使用默认数据
        this.setDefaultBanners();
      } finally {
        this.loading = false;
      }
    },
    setDefaultBanners() {
      // 设置默认的轮播图数据作为后备方案
      this.banners = [
        {
          title: '家用除湿机',
          subtitle: '智能高效的除湿器，让家居更健康',
          image_path: '/wimages/wb02.png',
          link_url: '/product5',
          link_text: '了解更多'
        },
        {
          title: 'Compact Crawlspace 除湿机',
          subtitle: 'Compact Crawlspace 除湿机',
          image_path: '/wimages/wb03.png',
          link_url: '/case',
          link_text: '了解更多'
        }
      ];
    },
    getImageUrl(imagePath) {
      if (!imagePath) return '/wimages/wb02.png'; // 默认图片

      // 如果是完整的URL，直接返回
      if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
      }

      // 如果是相对路径且不以/开头，添加/
      if (!imagePath.startsWith('/')) {
        return '/' + imagePath;
      }

      return imagePath;
    },
    processLinkUrl(url) {
      if (!url) return '';
      try {
        const urlObj = new URL(url);
        return urlObj.pathname + urlObj.search; // 返回路径和查询参数
      } catch (e) {
        console.error("Invalid URL for processing:", url, e);
        return url; // 如果URL无效，返回原始URL
      }
    }
  },
  setup() {
    return {
      Autoplay,
      Navigation,
      Pagination,
    };
  },
};
</script>

<style scoped>
.index-banner #swiper-button {
  position: absolute;
  bottom: 5%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
}

.index-banner .swiper-button {
  width: 3.5em;
  height: 3.5em;
  border-radius: 50%;
  border: 0.2em rgba(255, 255, 255, 0.5) solid;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 0 0.3em;
}

.index-banner .swiper-button img {
  width: 1em;
  height: auto;
}

.index-banner .swiper-button-next-c img {
  transform: rotate(180deg);
}

.default-link {
  display: inline-flex;
  align-items: center;
  cursor: default;
  opacity: 0.7;
}

.default-link i {
  margin-right: 0.3em;
}

/* Banner图片响应式处理 */
.banner-image {
  width: 100%;
  height: auto;
  object-fit: cover;
  display: block;
}

/* Banner文字样式 */
.index-banner dl dd h2 {
  font-size: 2em;
  margin-bottom: 0.5em;
}

.index-banner dl dd p {
  font-size: 1.2em;
  margin-bottom: 1em;
}

.index-banner dl dd a i,
.index-banner dl dd .default-link i {
  font-size: 1em;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .index-banner #swiper-button {
    bottom: 3%;
  }
  
  .index-banner .swiper-button {
    width: 2.5em;
    height: 2.5em;
    border: 0.15em rgba(255, 255, 255, 0.5) solid;
  }
  
  .index-banner dl dd h2 {
    font-size: 1.5em;
  }
  
  .index-banner dl dd p {
    font-size: 1em;
  }
}

@media (max-width: 480px) {
  .index-banner #swiper-button {
    bottom: 2%;
  }
  
  .index-banner .swiper-button {
    width: 2em;
    height: 2em;
  }
  
  .index-banner dl dd h2 {
    font-size: 1.2em;
  }
  
  .index-banner dl dd p {
    font-size: 0.9em;
  }
  
  .index-banner dl dd a i,
  .index-banner dl dd .default-link i {
    font-size: 0.9em;
  }
}
</style>